// extracted by mini-css-extract-plugin
export default {"wrapper":"Edtrns","left":"l2fnPj"};